// extracted by mini-css-extract-plugin
export default {"app":"App_app__mODAw","appContainer":"App_appContainer__+KbSo"};